export default {
    // 通用
    pageTitle: '合規出入金開戶',
    compliancePageTitle: '復星國際證券客戶資料複核',
    confirm: '確認',
    cancel: '取消',
    next: '下一步',
    previous: '上一步',
    save: '保存',
    submit: '提交',
    complete: '完成',
    loading: '加載中...',
    
    // 页面标题
    complianceIndex: '合規出入金開戶',
    passwordVerify: '交易密碼驗證',
    jobStatus: {
        // 基础信息
        zyzk: '職業狀況',
        zgxl: '最高學歷',
        qxzzgxl: '請選擇最高學歷',
        zyzt: '職業狀態',
        qxzzyzt: '請選擇職業狀態',
        gsmc: '公司名稱',
        qsrgsmc: '請輸入公司名稱',
        selectGs: '請選擇公司',
        bgsdz: '辦公室地址',
        qsrbgsdzxx: '請輸入辦公室地址信息',
        hangye: '公司行業',
        qxzhy: '請選擇公司行業',
        zhiwei: '職位',
        qxzzy: '請選擇職位',
        gznq: '工作年期',
        qxzgznq: '請選擇工作年期',

        // 学历选项
        xxhyx: '小學或以下',
        zhongxue: '中學',
        ykhzsxy: '預科或專上學院',
        dx: '大學',
        sshys: '碩士或以上',

        // 职业状态选项
        sg: '受雇',
        zg: '自雇',
        tx: '退休',
        xs: '學生',
        wy: '無業',

        // 投资来源
        tzzjlydx: '投資資金來源（多選）',
        jiating: '家庭',
        jianzhixinjin: '兼職薪金',
        zujin: '租金',
        tuixiujin: '退休金',
        fdctzsy: '房地產投資收益',
        jrsctzsy: '金融市場投資收益',
        qtlwbc: '其他勞務報酬',

        // 财务状况
        cwzk: '債務狀況',
        wzw: '無債務',
        fd: '房貸',
        qtzw: '其他債務',
        brwzwjf: '本人無債務糾紛',
        yzwjfzbzckh: '有債務糾紛，請聯繫客服進行線下開戶。',

        // 公司搜索
        wgsxx: '無公司信息',
        xzhy: '選擇行業',
        inputCompanyInfo: '填寫公司信息',
        qsrgsWZmcPlaceholder: '公司名稱不能少於4個字',
        CompanyAddressTip: '請確認公司地址準確無誤',
        SamePrompt: '公司名稱和地址不能相同',

        // 职位选项
        gaoguan: '高管',
        zhongceng: '中層管理',
        putong: '普通員工',
        ziyou: '自由職業',
        qita: '其他',

        // 行业选项
        jinrong: '金融',
        keji: '科技',
        yiliao: '醫療',
        jiaoyu: '教育',
        zhizao: '製造',
        maoyi: '貿易',
        fangdichan: '房地產',
        lvyou: '旅遊',
        chuanmei: '傳媒',
        nengyuan: '能源',
        nongye: '農業',
        jianzhu: '建築',
        yunyu: '運輸',
        canyin: '餐飲',
        fushi: '服飾',
        jiaju: '家具',
        huagong: '化工',
        dianzi: '電子',
        ruanjian: '軟件',
        hulianwang: '互聯網',
        dianshang: '電商',
        wuliu: '物流',
        baoxian: '保險',
        falv: '法律',
        zixun: '諮詢',
        guanggao: '廣告',
        sheji: '設計',
        yishu: '藝術',
        yule: '娛樂',
        tiyu: '體育',
        huanbao: '環保',
        gongyi: '公益',
        zhengfu: '政府',
        junshi: '軍事',
        zongjiao: '宗教',
        qitahangye: '其他行業',

        // 工作年限选项
        yinianyixia: '一年以下',
        yidaosannian: '一到三年',
        sandaowunian: '三到五年',
        wudaoshinian: '五到十年',
        shinianshang: '十年以上',

        // 验证信息
        qxzjyzt: '請選擇就業狀態',
        qsrgsmc2: '請輸入公司名稱',
        qsrbgsdz: '請輸入辦公室地址',
        qxzhy2: '請選擇行業',
        qsrzw: '請輸入職位',
        qxzgznx: '請選擇工作年限',

        // 其他
        xxBefor: '如有疑問，請聯繫',
        xxAfter: '。',
    },
    finance: '財務狀態',
    informationSupplement: '補充信息',
    backgroundDisclosure: '背景狀況披露',
    signature: '簽署姓名',
    complianceAudit: '合規審核',
    
    // 职业状况页面
    jobStatusPage: {
        title: '職業狀況',
        subtitle: '請填寫您的職業相關信息',
        education: '教育程度',
        employment: '就業狀況',
        companyName: '公司名稱',
        companyAddress: '公司地址',
        industry: '行業',
        position: '職位',
        workYears: '工作年限',
        
        // 教育程度选项
        educationOptions: {
            highSchool: '高中及以下',
            college: '大專',
            bachelor: '本科',
            master: '碩士',
            doctor: '博士'
        },
        
        // 就业状况选项
        employmentOptions: {
            employed: '在職',
            selfEmployed: '自雇',
            unemployed: '無業',
            retired: '退休',
            student: '學生'
        },
        
        // 工作年限选项
        workYearsOptions: {
            lessThan1: '少於1年',
            oneToThree: '1-3年',
            threeToFive: '3-5年',
            fiveToTen: '5-10年',
            moreThanTen: '10年以上'
        },
        
        // 验证信息
        validation: {
            educationRequired: '請選擇教育程度',
            employmentRequired: '請選擇就業狀況',
            companyNameRequired: '請輸入公司名稱',
            companyAddressRequired: '請輸入公司地址',
            industryRequired: '請選擇行業',
            positionRequired: '請輸入職位',
            workYearsRequired: '請選擇工作年限'
        }
    },
    
    // 财务状态页面
    financePage: {
        title: '財務狀態',
        subtitle: '請填寫您的財務相關信息',
        annualIncome: '年收入',
        netWorth: '淨資產',
        investmentExperience: '投資經驗',
        riskTolerance: '風險承受能力',
        investmentObjective: '投資目標'
    },
    
    // InformationSupplement 补充信息翻译键
    InformationSupplement: {
        title: '補充信息',
        fundSourceTitle: '資金來源地（多選）',
        tradingFrequencyTitle: '過去一年每月交投次數',
        thirdPartyTransferTitle: '過去一年是否存在第三者匯入/匯出款項',
        moneyLaunderingTitle: '過去一年是否牽涉關於洗錢的訴訟',
        spouseAccountTitle: '您的配偶、您自己是否存在與配偶共同操作另一個復星國際證券的賬戶',
        yes: '是',
        no: '否',
        fundSourceOptions: {
            hongkong: '香港',
            mainland: '中國大陸',
            macau: '澳門',
            singapore: '新加坡',
            usa: '美國',
            canada: '加拿大',
            other: '其他'
        },
        fundSourceOtherLabel: '請填寫具體的資金來源地',
        fundSourceOtherPlaceholder: '請輸入',
        thirdPartyTransferDetailLabel: '請填寫詳細說明',
        thirdPartyTransferDetailPlaceholder: '請輸入第三者匯入/匯出款項的詳細說明',
        moneyLaunderingDetailLabel: '請填寫詳細說明',
        moneyLaunderingDetailPlaceholder: '請輸入洗錢訴訟的詳細說明',
        spouseAccountLabel: '賬戶號',
        spouseAccountPlaceholder: '請輸入賬戶號碼',
        tradingFrequencyOptions: {
            lessThan1: '少於1次',
            '1to10': '1-10次',
            '11to20': '11-20次',
            moreThan21: '20次以上'
        }
    },

    // 补充信息页面
    supplementPage: {
        title: '補充信息',
        subtitle: '請填寫補充信息',
        politicallyExposed: '是否為政治敏感人員',
        pepDetails: 'PEP詳情',
        sourceOfFunds: '資金來源',
        expectedTransactionVolume: '預期交易量'
    },
    
    // 背景状况披露页面
    backgroundPage: {
        title: '背景狀況披露',
        subtitle: '請如實填寫背景信息',
        criminalRecord: '是否有犯罪記錄',
        criminalDetails: '犯罪記錄詳情',
        bankruptcyRecord: '是否有破產記錄',
        bankruptcyDetails: '破產記錄詳情',
        regulatoryAction: '是否受過監管處罰',
        regulatoryDetails: '監管處罰詳情'
    },
    
    // 签署页面
    signaturePage: {
        title: '簽署姓名',
        subtitle: '請簽署您的姓名',
        signature: '簽名',
        signatureDate: '簽署日期',
        agreement: '我確認以上信息真實有效'
    },
    
    // 合规审核页面
    auditPage: {
        title: '合規審核',
        subtitle: '您的申請正在審核中',
        status: '審核狀態',
        pending: '審核中',
        approved: '已通過',
        rejected: '已拒絕',
        reviewDate: '審核日期',
        reviewComments: '審核意見'
    },
    
    // C_SearchCompany 相關文案
    'C_SearchCompany': {
        noSearch: '查不到公司?',
        searchNoData: '暫無搜索結果',
        inputCompanyInfo: '填寫公司信息'
    },

    // 通用按鈕文案
    determine: '確定',

    // 合規狀態頁面
    complianceStatus: {
        defaultRejectReason: '資料審核不通過，請根據提示補充相關信息',
        commonRejectReasons: {
            documentUnclear: '提供的證明文件不清晰，請重新上傳高清版本',
            documentIncomplete: '資料不完整，請補充相關證明文件',
            informationInconsistent: '提供的信息前後不一致，請核實後重新填寫',
            documentExpired: '提供的證明文件已過期，請上傳有效期內的文件',
            signatureInvalid: '簽名不符合要求，請重新簽署'
        }
    },

    // 错误信息
    errors: {
        networkError: '網絡錯誤，請重試',
        validationError: '請檢查輸入信息',
        submitError: '提交失敗，請重試',
        loadError: '加載失敗，請刷新頁面'
    },
    
    // 成功信息
    success: {
        saved: '保存成功',
        submitted: '提交成功',
        completed: '完成'
    },

    // BackgroundDisclosure 背景披露翻譯鍵
    BackgroundDisclosure: {
        title: '背景狀況披露',
        politicalPersonTitle: '您是否為政治敏感人員或與政治敏感人員有關聯？',
        fatfMemberTitle: '您是否來自FATF成員國？',
        highRiskIndustryTitle: '您是否從事高風險行業？',
        otherRiskFactorsTitle: '您是否存在其他高風險因素？',
        yes: '是',
        no: '否',
        politicalPersonDetailLabel: '請填寫詳細說明',
        politicalPersonDetailPlaceholder: '請說明您是政治敏感人員的原因',
        fatfMemberDetailLabel: '請填寫詳細說明',
        fatfMemberDetailPlaceholder: '請說明您來自FATF成員國的原因',
        highRiskIndustryDetailLabel: '請填寫詳細說明',
        highRiskIndustryDetailPlaceholder: '請說明您從事高風險行業的原因',
        otherRiskFactorsDetailLabel: '請填寫詳細說明',
        otherRiskFactorsDetailPlaceholder: '請說明您存在其他高風險因素的原因',
    }
}
